import React from 'react';

const areas = [
  {
    title: 'Professional quote builder',
    hook: 'Organized from first quote to final invoice',
    body: 'Build accurate quotes with real material pricing by location, labor rates, tax, overhead, and markup in one workflow. Material search is included on Pro.',
    accent: 'from-primary/15 to-cyan-500/10',
  },
  {
    title: 'Project and client workspace',
    hook: 'Every job detail in one dashboard',
    body: 'Run projects with change orders, daily notes, before/after photos, receipts, and downloadable job documents tied to each client and job. Included on Pro.',
    accent: 'from-slate-100 to-cyan-50/80',
  },
  {
    title: 'Team member portal',
    hook: 'Give your crew secure access without sharing your login',
    body: 'Invite up to two team members on Pro. They get their own portal login, see only assigned projects, and you control permissions per job.',
    accent: 'from-cyan-950/5 to-cyan-100/80',
  },
  {
    title: 'Professional documents and delivery',
    hook: 'Branded PDFs and clean client communication',
    body: 'Generate quote and invoice PDFs with your company logo. Email polished documents directly from Devello on Pro.',
    accent: 'from-cyan-50/90 to-slate-50',
  },
];

const ProductAreasSection = () => {
  return (
    <section className="border-t border-slate-200/80 bg-white py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-3xl text-center md:mb-14">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Platform overview</p>
          <h2 className="mt-3 text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
            A complete contractor management platform for daily operations.
          </h2>
          <p className="mt-3 text-slate-600">
            Free covers quoting, clients, and PDFs. Pro adds projects, team portal access, material search, and email delivery from Devello.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {areas.map((a) => (
            <div
              key={a.title}
              className={`rounded-2xl border border-slate-200/90 bg-gradient-to-br ${a.accent} p-6 shadow-sm md:p-8`}
            >
              <p className="text-xs font-bold uppercase tracking-wide text-slate-500">{a.title}</p>
              <h3 className="mt-2 text-lg font-bold text-slate-900 md:text-xl">{a.hook}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 md:text-base">{a.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductAreasSection;
